export default "__VITE_ASSET__DtqL8qN2__"